<script>
import { Cell, Image, ImagePreview } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'image-viewer',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-image': Image,
        [ImagePreview.Component.name]: ImagePreview.Component
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        imageUrl: String,
        previewImageUrl: String,
        imageWidth: Number,
        imageHeight: Number,
	},

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        imgWidthField() {
            return this.imageWidth ? this.imageWidth : 80
        },
        imgHeightField() {
            return this.imageHeight ? this.imageHeight : 80
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onImageClick() {
            if (this.previewImageUrl) {
                ImagePreview({
                    images: [this.previewImageUrl],
                    showIndex: false
                })
            }     
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="image-viewer van-cell no-padding">
        <van-cell 
            :title="label"
            center
        >
            <template #default>
                <van-image 
                    v-if="imageUrl"
                    :src="imageUrl" 
                    :width="imgWidthField" 
                    :height="imgHeightField"
                    @click="onImageClick"
                />
                <img 
                    v-else
                    src="@/assets/org/logo-symbol.png" 
                    style="width: 80px; height: 80px;"
                />
            </template>
        </van-cell>
    </div>
</template>

<style scoped>
.image-viewer .van-cell__value {
    flex: 3;
}
</style>